import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagNO = function FlagNO() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "norway"
  }, /*#__PURE__*/React.createElement(Shape, {
    id: "white",
    fill: "#FFF",
    d: "M0,90a90,90 0 1,0 180,0a90,90 0 1,0 -180,0"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M60,174.878829 C69.3833676,178.195374 79.4809372,180 90,180 C134.594947,180 171.614453,147.565702 178.755624,105 L178.755624,105 L60,105 L60,174.878829 L60,174.878829 L60,174.878829 L60,174.878829 L60,174.878829 Z M30,157.083197 C15.1178273,143.763292 4.69435516,125.563962 1.24437643,105 L30,105 L30,157.083197 L30,157.083197 L30,157.083197 L30,157.083197 L30,157.083197 Z M60,5.12117063 C69.3833676,1.8046264 79.4809371,0 90,0 C134.594947,0 171.614453,32.4342982 178.755624,75 L178.755624,75 L60,75 L60,5.12117063 L60,5.12117063 L60,5.12117063 L60,5.12117063 L60,5.12117063 Z M30,22.916803 C15.1178273,36.2367078 4.69435516,54.4360378 1.24437643,75 L30,75 L30,22.916803 L30,22.916803 L30,22.916803 L30,22.916803 L30,22.916803 Z",
    id: "red",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M35,80 L35,18.7554761 C41.0935776,14.0443865 47.8081455,10.0976905 55,7.05909179 L55,80 L179.450712,80 C179.813667,83.2833385 180,86.619909 180,90 C180,93.380091 179.813667,96.7166615 179.450712,100 L55,100 L55,172.940908 C47.8081455,169.90231 41.0935776,165.955614 35,161.244524 L35,100 L0.549287698,100 C0.186333089,96.7166615 0,93.380091 0,90 C0,86.619909 0.186333089,83.2833385 0.549287698,80 L35,80 L35,80 Z",
    id: "blue",
    fill: "#227FBB"
  })));
};

FlagNO.displayName = 'FlagNO';
export default withFlagWrapper(FlagNO);
//# sourceMappingURL=index.js.map